import { render, staticRenderFns } from "./BulkDocumentsPdfsDeleteDialog.vue?vue&type=template&id=78817e95&scoped=true"
import script from "./BulkDocumentsPdfsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BulkDocumentsPdfsDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78817e95",
  null
  
)

export default component.exports